import { render } from "./NoProducts.vue?vue&type=template&id=e630921c&scoped=true"
import script from "./NoProducts.vue?vue&type=script&lang=js"
export * from "./NoProducts.vue?vue&type=script&lang=js"

import "./NoProducts.vue?vue&type=style&index=0&id=e630921c&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e630921c"]])

export default __exports__